import React from "react"
import ReportDivisions from "./fields/ReportDivisions"
import ReportFacilities from "./fields/ReportFacilities"
import ReportAccountingBatches from "./fields/ReportAccountingBatches"
import ReportDateRange from "./fields/ReportDateRange"
import ReportVendors from "./fields/ReportVendors"
import ReportBillableAccounts from "./fields/ReportBillableAccounts"
import ReportSupplyAccounts from "./fields/ReportSupplyAccounts"

export default function TrialBalance() {
    return (
        <div>
            <ReportDateRange required={false} />
            <ReportAccountingBatches />
            <ReportDivisions />
            <ReportFacilities />
            <ReportVendors />
            <ReportBillableAccounts />
            <ReportSupplyAccounts />
        </div>
    )
}
